import React from 'react';

import classes from './InfoSection.module.scss';

type InfoSectionProps = {
  title: string;
  description: string;
  helperText?: string;
  className?: string;
};

const InfoSection = ({ title, description, helperText, className }: InfoSectionProps) => {
  return (
    <div className={className}>
      <p className={classes.title}>{title}</p>
      <p className={classes.description}>{description}</p>
      {helperText && <p className={classes.heplerText}>{helperText}</p>}
    </div>
  );
};

export { InfoSection };
